{
  "verified": "Geprüft",
  "iv_status": {
    "verified": "Geprüft",
    "pending": "Anhängig",
    "attention": "Achtung"
  },
  "zoom_in": "Vergrößern",
  "zoom_out": "Herauszoomen",
  "rotate": "Drehen Sie",
  "close": "Schließen",
  "esc_to_close": "Zum Schließen ESC drücken",
  "play": "Spielen",
  "pause": "Pause",
  "mute": "Stummschalten",
  "unmute": "Aufheben der Stummschaltung",
  "enter_full_screen": "Vollbild eingeben",
  "exit_full_screen": "Vollbild beenden",
  "video_not_supported": "Ihr Browser unterstützt das Video-Tag nicht.",
  "skip_forward": "Vorwärts springen",
  "skip_backward": "Rückwärts springen",
  "loading": "Laden",
  "loading_video": "Video wird geladen...",
  "loading_data_description": "Bitte warten Sie, während wir Ihre Daten laden. Dies wird nicht lange dauern.",
  "no_results": "Keine Ergebnisse",
  "nothing_found": "Nichts gefunden",
  "save_changes": "Änderungen speichern",
  "saved_exclamation": "Gerettet!",
  "saving": "Sparen",
  "validating": "Validierung",
  "error": "Fehler",
  "optional": "Optional",
  "search_property": "Eigenschaft suchen",
  "reset_search": "Suche zurücksetzen",
  "no_items_to_show": "Keine Artikel zu zeigen",
  "showing_range_of_total_items": "Zeigt {{range}} von {{total}} Artikeln",
  "rows_per_page": "Zeilen pro Seite",
  "page_of_pages": "Seite {{page}} von {{pages}}",
  "go_to_first_page": "Zur ersten Seite gehen",
  "go_to_previous_page": "Zur vorherigen Seite gehen",
  "go_to_next_page": "Weiter zur nächsten Seite",
  "go_to_last_page": "Gehe zur letzten Seite",
  "sort_in_asc": "In aufsteigender Reihenfolge sortieren",
  "sort_in_desc": "In absteigender Reihenfolge sortieren",
  "clear_sorting": "Eindeutige Sortierung",
  "sort_a_z": "A → Z sortieren",
  "sort_z_a": "Z → A sortieren",
  "reach_us_at_email": "Erreichen Sie den Support unter support@chekin.com",
  "please_wait": "Bitte warten",
  "feature_coming_soon": "Bald verfügbar",
  "feature_coming_soon_description": "Diese Funktion ist derzeit in Entwicklung und wird bald verfügbar sein. Bleiben Sie auf dem Laufenden für Updates!",
  "beta": "Beta",
  "download_all": "Alle herunterladen",
  "entry_forms": "Anmeldeformulare",
  "tutorial": "Tutorial",
  "liveness_video": "Lebendigkeit-Video",
  "reviews": "Bewertungen",
  "learn_more": "Mehr erfahren",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "Kopiert!",
  "search_placeholder": "Suche...",
  "type_to_search": "Tippen Sie für die Suche...",
  "loading_more": "Laden...",
  "no_options": "Keine Optionen",
  "select_option": "Option auswählen",
  "clear_all": "Alle löschen",
  "remove_item": "{{label}} entfernen",
  "upload_file": "Datei hochladen",
  "download_attachment": "Anhang herunterladen",
  "remove_file": "Datei entfernen",
  "open_calendar": "Kalender öffnen",
  "clear_dates": "Daten löschen",
  "select_dates": "Daten auswählen",
  "pick_date_range": "Wählen Sie einen Datumsbereich",
  "from": "Von",
  "to": "An",
  "pick_month": "Wählen Sie einen Monat",
  "pick_date": "Wählen Sie ein Datum",
  "month": "Monat",
  "day": "Tag",
  "year": "Jahr",
  "done": "Erledigt",
  "wrong_period_of_dates": "Ausgewählter Zeitraum ist ungültig",
  "date_range_max_days_error_one": "Der Bereich kann {{count}} Tag nicht überschreiten",
  "date_range_max_days_error_other": "Der Bereich kann {{count}} Tage nicht überschreiten",
  "date_range_min_days_error_one": "Der Bereich muss mindestens {{count}} Tag betragen",
  "date_range_min_days_error_other": "Die Reichweite muss mindestens {{count}} Tage betragen",
  "past_dates": "Das Datum kann nicht vor {{minDate}} liegen.",
  "future_dates": "Das Datum kann nicht nach {{maxDate}} liegen.",
  "signature_placeholder_text": "Unterschreibe in diesem Feld.<br/> Benutze deinen Finger.<br/> Tippe zum Starten.",
  "open_devices_camera": "Öffnen Sie die Kamera des Geräts",
  "place_document_inside_frame": "Legen Sie Ihr Dokument in den Rahmen",
  "close_other_application_that_may_be_using_your_camera": "Schließen Sie andere Anwendungen, die möglicherweise Ihre Kamera verwenden",
  "if_you_use_external_camera_disconnect_and_reconnect": "Wenn Sie eine externe Kamera verwenden, trennen Sie sie ab und schließen Sie sie wieder an.",
  "close_the_browser_re_open_it": "Schließen Sie den Browser und öffnen Sie ihn erneut",
  "camera_errors": {
    "experiencing_camera_issues": "Haben Sie Probleme mit der Kamera?",
    "chekin_cant_use_your_camera": "Chekin kann deine Kamera nicht benutzen",
    "please_try_a_different_browser": "Ihre Kamera funktioniert in diesem Browser nicht. Bitte versuchen Sie, den Link in einem anderen Browser zu öffnen.",
    "permissions_denied": "Erlaubnis verweigert",
    "camera_permissions_denied": "Die Kamera lässt sich nicht öffnen? Stellen Sie sicher, dass Sie dem Browser die Verwendung der Kamera erlauben.",
    "no_camera_device_found": "Kein Kameragerät gefunden. Bitte schließen Sie eine Kamera an.",
    "constraints_camera_error": "Einschränkungen können nicht von den verfügbaren Geräten erfüllt werden.",
    "safari_camera_error": "Safari konnte die Anforderungen der Kamera nicht erfüllen",
    "try_chrome_or_firefox": "Bitte versuchen Sie Chrome oder Firefox"
  },
  "clear": "Klar",
  "show_less": "Weniger anzeigen",
  "show_more": "Mehr anzeigen",
  "tap_here_to_sign": "Zum Unterschreiben hier tippen",
  "click_here_to_sign": "Zum Unterschreiben hier klicken",
  "prefix": "Vorsilbe",
  "prefix_required": "Präfix ist erforderlich",
  "reset": "Zurücksetzen",
  "show_password": "Passwort anzeigen",
  "hide_password": "Passwort verstecken",
  "increment": "Inkrement",
  "decrement": "Verkleinern",
  "create_option": "Erstellen Sie \"{{input}}\".",
  "year_out_of_range": "Das Jahr muss zwischen {{min}} und {{max}} liegen",
  "clear_date": "Datum löschen",
  "select_date": "Datum auswählen",
  "draw_signature_here": "Bitte unterschreiben Sie hier",
  "signature_hint": "Benutze deine Maus oder deinen Finger",
  "clear_signature": "Deutliche Unterschrift",
  "draw_signature_here_mobile": "Schreiben Sie Ihre Unterschrift",
  "signature_hint_mobile": "Benutze deinen Finger",
  "camera_access_needed": "Kamerazugriff erforderlich",
  "camera_access_needed_text": "Erlauben Sie der Kamera den Zugriff, um das Foto aufzunehmen. Falls dies blockiert ist, aktivieren Sie die Kamera in Ihren Browsereinstellungen und versuchen Sie es dann erneut.",
  "dialog": "Dialog"
}
